export default __webpack_public_path__ + "static/media/1694_1696.ba0ba224.JPG";